import { lightbox, lightboxSlide } from '../../resources/js/utils/lightbox'

window.addEventListener('load', () => {
	lightbox('.lightbox', true)
});


window.addEventListener('click', (event) => {
	lightboxSlide(event)
});
